module.exports = __webpack_public_path__ + "img/17_4.49368f76.png";